/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 09:57:41
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
import { defaultNullValue } from 'src/config';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
export declare namespace DeclareMalfunctionDOI {
    export interface RowDataI {
        auditor: string
        cause: string
        declare_type: number
        fault_number: string
        fault_site: any;
        id: number
        initiator: string
        sponsor_datetime: string
        status: number
    }

    export interface QueryRowDataParamsI extends PageDo {
        keyword?: string;
        end_time?: Integer;
        start_time?: Integer;
        status?: Integer;
        declare_type?: Integer;
    }

    export interface QueryDetailResultI {
        cause: string
        declare_type_id: number
        declare_type: string
        initiator: string;
        fault_site: any
        operational_time: number
        fault_number: string
        sponsor_datetime: string
        status: number;
        refuse_cause: string;
        audit_time: string
        auditor: string
        nosubmit_cause: string;
        submit_datatime: string
        submitter: string
    }

    export interface OperateParamsI {
        id?: Integer
        declare_type: Integer
        operational_time: Integer
        cause: string
        fault_site: any
    }
}
export default class DeclareMalfunctionApi {
    /**
     * 查询列表
     * @param {DeclareMalfunctionDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(params: DeclareMalfunctionDOI.QueryRowDataParamsI): Promise<ResultPageDo<DeclareMalfunctionDOI.RowDataI[]>> {
        return Api.post('/ops/fault_declare/list/get', {
            declare_type: defaultNullValue,
            status: defaultNullValue,
            keyword: '',
            end_time: DateTimeUtil.getSecondFromIviewDate(new Date()),
            start_time: DateTimeUtil.getSecondFromIviewDate(new Date('1990')),
            ...params,
        });
    }
    /**
     * 查询列表
     * @param {{id: number}} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchDetail(params: { id: number }): Promise<Result<DeclareMalfunctionDOI.QueryDetailResultI>> {
        return Api.post('/ops/fault_declare/particulars/get', params);
    }
    /**
     * 新增
     * @param {DeclareMalfunctionDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async add(data: DeclareMalfunctionDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/ops/fault_declare/add', data);
    }

    /**
     * 修改
     * @param {DeclareMalfunctionDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async update(data: DeclareMalfunctionDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/ops/fault_declare/edit', data);
    }

    /**
     * 删除
     * @param {Array<number>} data
     * @returns {Promise<Result<any>>}
     */
    static async delete(data: { ids: Array<number> }): Promise<Result<any>> {
        return Api.post('/ops/fault_declare/batch/delete', data);
    }

    static async batchSubmit(data:{ids: number[], nosubmit_cause: string, status:number,timestamp:Integer}): Promise<Result<any>> {
        return Api.post('/ops/fault_declare/batch/submit', data);
    }

    static async batchAudit(data:{ids: number[], refuse_cause: string, status:number, timestamp:Integer}): Promise<Result<any>> {
        return Api.post('/ops/fault_declare/batch/check', data);
    }
}
